module.exports = __webpack_public_path__ + "static/68c75a22-6435-4e26-8ef9-fe635c944f3f-f7713c7c3b452e9e33f0dfe6988e5efa.jpeg";